// Messages for operator/shipments/CargoFormModal (auto-merged by lib/i18n.ts).
export const en = {
  'operator.cargo_form.title': 'Edit cargo details',
  'operator.cargo_form.cancel': 'Cancel',
  'operator.cargo_form.save': 'Save cargo',
  'operator.cargo_form.section.summary': 'Cargo summary',
  'operator.cargo_form.section.containers': 'Containers & packages',
  'operator.cargo_form.field.total_weight': 'Total gross weight (kg)',
  'operator.cargo_form.field.total_volume': 'Total volume (CBM)',
  'operator.cargo_form.no_containers': 'No containers yet — add one below.',
  'operator.cargo_form.add_container': 'Add container',
  'operator.cargo_form.remove': 'Remove container',
  'operator.cargo_form.col.container': 'Container / AWB',
  'operator.cargo_form.col.type': 'Type',
  'operator.cargo_form.col.weight': 'Weight (kg)',
  'operator.cargo_form.col.cbm': 'CBM',
  'operator.cargo_form.section.parcels': 'Loose parcels',
  'operator.cargo_form.no_parcels': 'No loose parcels yet — add one below.',
  'operator.cargo_form.add_parcel': 'Add parcel',
  'operator.cargo_form.remove_parcel': 'Remove parcel',
  'operator.cargo_form.col.ref': 'Reference',
  'operator.cargo_form.col.tracking': 'Tracking no.',
  'operator.cargo_form.col.width': 'Width (cm)',
  'operator.cargo_form.col.height': 'Height (cm)',
  'operator.cargo_form.col.length': 'Length (cm)',
}

export const zhTW = {
  'operator.cargo_form.title': '編輯貨物明細',
  'operator.cargo_form.cancel': '取消',
  'operator.cargo_form.save': '儲存貨物',
  'operator.cargo_form.section.summary': '貨物摘要',
  'operator.cargo_form.section.containers': '貨櫃與包裹',
  'operator.cargo_form.field.total_weight': '總毛重（公斤）',
  'operator.cargo_form.field.total_volume': '總體積（CBM）',
  'operator.cargo_form.no_containers': '尚無貨櫃 — 於下方新增。',
  'operator.cargo_form.add_container': '新增貨櫃',
  'operator.cargo_form.remove': '移除貨櫃',
  'operator.cargo_form.col.container': '貨櫃 / 提單號',
  'operator.cargo_form.col.type': '類型',
  'operator.cargo_form.col.weight': '重量（公斤）',
  'operator.cargo_form.col.cbm': 'CBM',
  'operator.cargo_form.section.parcels': '散裝包裹',
  'operator.cargo_form.no_parcels': '尚無散裝包裹 — 於下方新增。',
  'operator.cargo_form.add_parcel': '新增包裹',
  'operator.cargo_form.remove_parcel': '移除包裹',
  'operator.cargo_form.col.ref': '參考編號',
  'operator.cargo_form.col.tracking': '追蹤號碼',
  'operator.cargo_form.col.width': '寬度（公分）',
  'operator.cargo_form.col.height': '高度（公分）',
  'operator.cargo_form.col.length': '長度（公分）',
}
